import React from "react";
import { useNavigate } from "react-router-dom";
import bgImage from "../../assets/library-bg.jpg";
// import logo from "../../assets/logo.png"; // Optional

const RoleSelection = () => {
  const navigate = useNavigate();

  const selectRole = (role) => {
    navigate("/Login", { state: { role } });
  };

  return (
    <div style={styles.container}>
      <div style={styles.overlay}>
        <div style={styles.card}>
          {/* Uncomment if you have logo */}
          {/* <img src={logo} alt="Logo" style={styles.logo} /> */}

          <h1 style={styles.title}>Ghalib Library</h1>

          <p style={styles.subtitle}>
            Library Management System
          </p>

          <p style={styles.description}>
            Please select your login portal to continue.
          </p>

          <button
            style={styles.button}
            onClick={() => selectRole("User")}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#000";
              e.target.style.color = "#fff";
              e.target.style.transform = "translateY(-3px)";
              e.target.style.boxShadow = "0 10px 25px rgba(0,0,0,0.25)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#fff";
              e.target.style.color = "#000";
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "none";
            }}
          >
            User Login
          </button>

          <button
            style={styles.button}
            onClick={() => selectRole("Librarian")}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#000";
              e.target.style.color = "#fff";
              e.target.style.transform = "translateY(-3px)";
              e.target.style.boxShadow = "0 10px 25px rgba(0,0,0,0.25)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#fff";
              e.target.style.color = "#000";
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "none";
            }}
          >
            Librarian Login
          </button>

          <button
            style={styles.button}
            onClick={() => selectRole("Admin")}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#000";
              e.target.style.color = "#fff";
              e.target.style.transform = "translateY(-3px)";
              e.target.style.boxShadow = "0 10px 25px rgba(0,0,0,0.25)";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#fff";
              e.target.style.color = "#000";
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "none";
            }}
          >
            Administrator Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default RoleSelection;

const styles = {
  container: {
    minHeight: "100vh",
    backgroundImage: `url(${bgImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop:"0px"
  },

  overlay: {
    width: "100%",
    height: "100vh",
    background: "rgba(0,0,0,0.55)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  card: {
    width: "420px",
    background: "rgba(255,255,255,0.96)",
    borderRadius: "18px",
    padding: "45px 35px",
    textAlign: "center",
    boxShadow: "0 20px 50px rgba(0,0,0,0.35)",
    backdropFilter: "blur(8px)",
  },

  logo: {
    width: "90px",
    marginBottom: "20px",
  },

  title: {
    fontSize: "34px",
    fontWeight: "700",
    color: "#111",
    marginBottom: "5px",
    letterSpacing: "1px",
  },

  subtitle: {
    fontSize: "17px",
    color: "#555",
    marginBottom: "8px",
    fontWeight: "500",
  },

  description: {
    fontSize: "15px",
    color: "#777",
    marginBottom: "35px",
    lineHeight: "24px",
  },

  button: {
    width: "100%",
    padding: "15px",
    marginBottom: "16px",
    border: "2px solid #111",
    backgroundColor: "#fff",
    color: "#111",
    borderRadius: "10px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all .3s ease",
  },
};